import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    removeAll: translate({ id: 'order.form.bulk.timeWindows.removeAll' }),
    moreTooltip: translate({ id: 'order.form.bulk.timeWindows.moreTooltip' }),

    deleteAllTimeWindowsDisabledTooltip: translate({
      id: 'order.form.bulk.timeWindows.deleteAllTimeWindowsDisabledTooltip',
    }),
  }))

  return api
}
